<template>
    <component :is="component" v-if="localized" v-bind="$props" />
    <div v-else class="pp-monthly-payment">{{ paymentPlan.monthlyAmountCents | currencyWhole }}/mo</div>
</template>

<script>
    import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin"

    export default {
        name: "PaymentPlanCost",
        mixins: [LocalizedComponentMixin],
        props: {
            financedAmountCents: {
                type: Number,
            },

            grouped: {
                type: Boolean,
            },

            paymentPlan: {
                type: Object,
                required: true,
            },

            providerKey: {
                type: String,
                required: true,
            },

            suggestedPayment: {
                type: Boolean,
            },

            estimatedMinimumPaymentCents: {
                type: Number,
                default: null,
            },
        },
        data() {
            return {
                componentType: "paymentPlanCost",
            }
        },
    }
</script>

<style lang="scss">
    .cost-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        width: 100%;
        height: 76px;
        background-color: $bg-color-neutral;
        border-radius: 8px;

        @media #{map-get($display-breakpoints, "sm-and-up")} {
            width: fit-content;
        }
    }

    .learn-how-link {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
    }

    .suggested-payment {
        font-size: 12px;
        color: $grey-darken-2;
    }

    .estimated-mo-text {
        font-size: 12px;
        font-weight: bold;
    }

    .genesis-size {
        font-size: 22px;
    }
</style>
